import {COUNTRIES_WITH_VAT} from '../../components/Checkout/constants';

export function isCountryWithVat(country?: string) {
  return country && COUNTRIES_WITH_VAT.includes(country);
}
